import React from 'react';
import DashboardSidebar from '../components/DashboardComponents/DashboardSidebar';
import InnerBanner from '../components/PagesComponents/InnerBanner';
import AdminNewsDetailInfo from '../components/AdminComponents/AdminNewsDetailInfo';
const AdminNewsDetail = () => {
 return (
    <>
<InnerBanner pageKey="adminNewsDetail" />

      <section className='dashboard'>
        <div className='container'>
            <div className='row'>
                <div className='col-lg-12'>
                   <AdminNewsDetailInfo/> 
                </div>
               
            </div>
        </div>
      </section>
    </>
 );

};

export default AdminNewsDetail;